import { render } from "./course-how-works.vue?vue&type=template&id=0edd92b1&ts=true"
import script from "./course-how-works.vue?vue&type=script&lang=ts"
export * from "./course-how-works.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__